"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../assets/styles/colors");
const media_1 = require("../../../utils/media");
const ScrollButton = styled_components_1.default.button `
  display: flex;
  align-items: center;
  border: none;
  justify-content: center;
  width: 32px;
  height: 40px;
  background-color: ${colors_1.gray100};

  @media ${media_1.media.desktop} {
    width: 40px;
    border-radius: 50%;
    border: 1px solid ${colors_1.gray200};
    background-color: white;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
exports.ScrollButton = ScrollButton;
